<template>
  <div class="class-notice-modal">
    <div
      class="backdrop"
      @click.self="$emit('close')"
    >
      <div class="modal">
        <div
        v-if="announcement"
        class="post"
        >
        <h3>{{ announcement.title }}</h3>
        <p class="pre">
            {{ announcement.content }}
        </p>
        <br>
        <button
            v-if="role === 'testAdmin' || role === 'teacher'"
            class="delete"
            @click="handleClick"
        >
            delete announcement
        </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db, doc, deleteDoc } from '@/firebase/config'
import getUser from '@/composables/getUser'
// import { inject } from 'vue'
export default {
  props: ['announcement'],
  setup (props, context) {
    const { user, role, grade } = getUser()
    // const currentUser = inject('currentUser')

    const handleClick = async () => {
      await deleteDoc(doc(db, '/schools/inspire-schools/' + grade.value + '/classannouncements/' + role.value, props.announcement.id))
      context.emit('deletion')
    }

    return { handleClick, user, role }
  }
}
</script>

<style>
.class-notice-modal .backdrop {
    top: 0;
    left: 0;
    position: fixed;
    background-color: fuchsia;
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
    display: grid;
    place-items: center;
    /* z-index: 99; */
}
.class-notice-modal .modal {
    border-radius: 10px;
    max-width: 400px;
    background: #fff;
    padding: .5em;
}
.post {
  background: #fff;
  max-width: 960px;
  margin: 0 auto;
  padding: 10px;
}
.pre {
  color: #777;
  padding: 15px auto;
  margin-bottom: 10px;
}
</style>
